import type { SVGProps } from 'react'

export type JurisdictionIconKind = 'state' | 'federal' | null

export function LocationPinIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" fill="none" aria-hidden="true" {...props}>
      <path d="M8 14s4.25-3.8 4.25-7.25A4.25 4.25 0 0 0 3.75 6.75C3.75 10.2 8 14 8 14Z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
      <circle cx="8" cy="6.75" r="1.35" stroke="currentColor" strokeWidth="1.4" />
    </svg>
  )
}

export function FederalCourthouseIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" fill="none" aria-hidden="true" {...props}>
      <path d="M2.75 6.25h10.5L8 3.25 2.75 6.25Z" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" />
      <path d="M4 6.25v5.25M6.65 6.25v5.25M9.35 6.25v5.25M12 6.25v5.25" stroke="currentColor" strokeWidth="1.2" />
      <path d="M3 11.5h10M2.5 13.25h11" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  )
}

export function JurisdictionIcon({ kind, ...props }: SVGProps<SVGSVGElement> & { kind: JurisdictionIconKind }) {
  if (kind === 'state') return <LocationPinIcon {...props} />
  if (kind === 'federal') return <FederalCourthouseIcon {...props} />
  return null
}
